define('view/controller/booking/datetime/DateTimeStepDefaultLayout',['require','lib/view/LayoutView','Config'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	var Config = require('Config');
	
	/**
	 * Default datetime step layout
	 * 
	 * @class DateTimeStepDefaultLayout
	 */
	return LayoutView.extend({
	
	    template: '#datetime_step_default_layout',
	    
	    regions: {
	    	date: '#sb_dateview_container',
	        time: '#sb_timeview_container',
			group: '#sb_group_booking_container',
			sidebar: '#sb_sidebar_container'
	    },
	
	    /**
	     * Returns region for datepicker
	     * 
	     * @return Marionette.Region
	     */
	    getDateRegion: function () {
	    	return this.date;
	    },
	    
	    /**
	     * Returns region for timepicker
	     * 
	     * @return Marionette.Region
	     */
	    getTimeRegion: function () {
	    	return this.time;
	    },

        /**
		 * Returns region for booking info sidebar
		 *
         * @return Marionette.Region
         */
        getSideBarRegion: function () {
	    	return this.sidebar;
		},

        /**
		 * Returns region for group booking plugin
		 *
		 * @return Marionette.Region
         */
		getGroupBookingRegion: function () {
			return this.group;
		},

        /**
		 * Returns true if timeline can have date navigation
		 *
         * @return boolean
         */
		supportsTimelineNavigation: function () {
	    	return true;
		},

        /**
		 * Returns true if layout supports sidebar with booking info
		 *
		 * @return boolean
         */
        supportsSidebar: function () {
			var timeline = Config.getInstance().getOption('timeline_type');
			var withoutSidebar = [Config.TIMELINE_CLASSES, Config.TIMELINE_CLASSES_PLUGIN, Config.TIMELINE_GRID_WEEKLY];
			if (_.contains(withoutSidebar, timeline)) {
				return false;
			}
			return true;
		},

        /**
		 * Pass additional data to view
		 *
		 * @return Object
         */
		serializeData: function () {
			return _.extend(
				LayoutView.prototype.serializeData.apply(this), {
                    supports_sidebar: this.supportsSidebar()
				}
			);
        }
	    
	});

});
